import React from 'react'
import Page from '../Page/Page'
import PageContent from '../Page/PageContent'
import TitleToolbar from '../Page/TitleToolbar'
import Question from './Question'
import * as urls from '../../constants/urls'
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'
import PdfIcon from '../Stompunkt/PdfIcon'
import PolygonIcon from '../MapMenu/PolygonIcon'
import GetAppIcon from '@material-ui/icons/GetApp'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import PlaceIcon from '@material-ui/icons/Place'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
   questionGroup: {
      paddingBottom: theme.spacing.unit * 3,
   },
   subheading: {
      fontSize: '14px',
   },
})

const HelpPage = ({ classes }) => (
   <Page>
      <TitleToolbar title="Hjälp" />
      <PageContent padding>

         <div className={classes.questionGroup}>

            <Typography variant="subheading">Om hur man använder tjänsten</Typography>

            <Question title="Hur hämtar jag punktbeskrivning för en enskild stompunkt?">
               <li>Navigera till stompunkten i kartan och klicka på den.</li>
               <li>Klicka på "Ladda ned PDF" <PdfIcon fontSize="inherit" /> i menyn högst upp.</li>
            </Question>

            <Question title="Hur hämtar jag information om flera stompunkter?">
               <li>Använd verktyget "Välj med polygon" <PolygonIcon fontSize="inherit" /> för att markera flera punkter i kartan.</li>
               <li>Du kan också lägga till punkter en och en genom att klicka på dem i kartan och sedan markera kryssrutan "Lägg till i urval" <CheckBoxOutlineBlankIcon fontSize="inherit" />.</li>
               <li>Välj fliken "Urval" och klicka på "Exportera urval" <GetAppIcon fontSize="inherit" />.</li>
               <li>Du kan nu välja vilket format du vill ha informationen i. När du klickar på "Exportera" laddar din webbläsare ned informationen.</li>
            </Question>

            <Question title="Hur hittar jag en punkt om jag bara vet dess ID?">
               <li>Klicka på "Sök stompunkt" <SearchIcon fontSize="inherit" /> i menyn i kartan.</li>
               <li>Skriv in ID (med eller utan organisationsnummer) och tryck enter.</li>
               <li>För att visa var punkten ligger på kartan, tryck på "Zooma till stompunkt" <PlaceIcon fontSize="inherit" />.</li>
            </Question>

         </div>

         <div className={classes.questionGroup}>

            <Typography variant="subheading">Om informationen</Typography>

            <Question title="Hur får jag använda informationen i denna tjänst?">
               <li>Informationen i tjänsten tillhandahålls som öppna data under licensen <a href={urls.CC0} rel="noopener noreferrer" target="_blank">CC0</a>.</li>
            </Question>

            <Question title="Vilka andra tjänster finns det?">
               <li><a href={urls.STOMPUNKT_VISNING} rel="noopener noreferrer" target="_blank">Stompunkt Visning</a> är en WMS som kan visa informationen i ditt eget GIS-program.</li>
               <li><a href={urls.STOMPUNKT_DIREKT} rel="noopener noreferrer" target="_blank">Stompunkt Direkt</a> kan användas för maskin-till-maskin kommunikaiton.</li>
            </Question>

            <Question title="Kan jag hjälpa till att hålla informationen uppdaterad?">
               <li>Ja, du kan <a href={urls.RÄTTA_I_DGA} rel="noopener noreferrer" target="_blank">lämna felrapporter</a> om förstörda punkter eller andra fel.</li>
            </Question>

            <Question title="Vart kan jag vända mig om jag har fler frågor?">
               <li>Kontakta <a href={urls.KONTAKT} rel="noopener noreferrer" target="_blank">Geodetiska arkivet</a>.</li>
            </Question>

            <Question title="Använder tjänsten cookies?">
               <li>Vi använder nödvändiga cookies för att vår webbplats ska fungera. Om du samtyckt till det sparar vi också cookies för statistik. Statistiken hjälper oss förstå hur besökare interagerar med webbplatsen.</li>
               <li>Statistiken samlas in anonymt och vi sparar inga personuppgifter.</li>
               <li>Se <a href={urls.LM_COOKIE_INFO} rel="noopener noreferrer" target="_blank">Lantmäteriets sida om cookies</a> för mer information.</li>
            </Question>

         </div>

      </PageContent>
   </Page>
)

export default withStyles(styles)(HelpPage)



// WEBPACK FOOTER //
// ./src/components/Help/HelpPage.js